var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import _ from 'lodash';
import moment from 'moment';
import pluralize from 'pluralize';
import i18nDict from './external/i18n';
import { toI18nKey } from './utils';

function ifExist(flag, str) {
  if (!flag) {
    return '';
  }

  if (typeof str === 'function') {
    return str(flag);
  }

  return str;
}

function splitBracket(origin) {
  var bracketResult = /^(.*?)( *)\(([^)]*)\)( *)(.*?)$/g.exec(origin);

  if (bracketResult) {
    var _o = bracketResult[0],
        // tslint:disable-line:no-unused
    body1 = bracketResult[1],
        space1_1 = bracketResult[2],
        body2 = bracketResult[3],
        space2_1 = bracketResult[4],
        body3 = bracketResult[5];
    return [[body1, body2, body3], function (tBody1, tBody2, tBody3) {
      return "" + tBody1 + space1_1 + "(" + tBody2 + ")" + space2_1 + tBody3;
    }];
  }

  return null;
}

function splitSquareBracket(origin) {
  var bracketResult = /^([^\[]*?)( *)\[([^ \]]+)\]( *)(.*?)$/g.exec(origin);

  if (bracketResult) {
    var _o = bracketResult[0],
        // tslint:disable-line:no-unused
    body1 = bracketResult[1],
        space1_2 = bracketResult[2],
        body2 = bracketResult[3],
        space2_2 = bracketResult[4],
        body3 = bracketResult[5];
    return [[body1, body2, body3], function (tBody1, tBody2, tBody3) {
      return "" + tBody1 + space1_2 + "(" + tBody2 + ")" + space2_2 + tBody3;
    }];
  }

  return null;
}

function splitColon(origin) {
  var bracketResult = /^(.*?)( *: *)(.*)$/g.exec(origin);

  if (bracketResult) {
    var _o = bracketResult[0],
        // tslint:disable-line:no-unused
    body1 = bracketResult[1],
        _mid = bracketResult[2],
        body2 = bracketResult[3];
    return [[body1, body2], function (tBody1, tBody2) {
      return tBody1 + "\uFF1A" + tBody2;
    }];
  }

  return null;
}

function splitDash(origin) {
  var dashResult = /^(.*?)( *)[—–-]( *)(.*)$/g.exec(origin);

  if (dashResult) {
    var _o = dashResult[0],
        // tslint:disable-line:no-unused
    body1 = dashResult[1],
        space1_3 = dashResult[2],
        space2_3 = dashResult[3],
        body2 = dashResult[4];

    if (!space1_3 && !space2_3) {
      return null;
    }

    return [[body1, body2], function (tBody1, tBody2) {
      return "" + tBody1 + (space1_3 && ' ') + "-" + (space2_3 && ' ') + tBody2;
    }];
  }

  return null;
}

function splitXXXTalents(origin) {
  var bracketResult = /^(.*?) TALENTS$/g.exec(origin);

  if (bracketResult) {
    var _o = bracketResult[0],
        // tslint:disable-line:no-unused
    name = bracketResult[1];
    return [[name], function (tName) {
      return tName + "\u5929\u8D4B";
    }];
  }

  return null;
}

function strEq(a, b) {
  return a.toLowerCase() === b.toLowerCase();
} // tslint:disable-next-line:max-func-body-length


function translatePreset(origin) {
  var regexps = [[/^Level (\d*)$/i, '$1级'], [/^Moved from level (\d*) to level (\d*).?$/i, '从$1级移到$2级'], [/^Moved from level (\d*).?$/i, '移自$1级'], [/^Moved to level (\d*).?$/i, '移至$1级'], [/^heroes of the storm (ptr )?(balance )?(live )?(hotfix )?(patch )?notes$/gi, function (r) {
    return "\u300A\u98CE\u66B4\u82F1\u96C4\u300B" + ifExist(r[1], '公开测试服') + ifExist(r[2], '平衡') + ifExist(r[3], '正式服') + ifExist(r[4], '在线修正') + "\u66F4\u65B0\u8BF4\u660E";
  }], [/^orange text indicates a (:?difference|change) between (the )?ptr and live (patch )? notes.$/gi, function (r) {
    return '橙色文字表示公开测试服与正式服日志之间的区别';
  }], [/^now (.*)$/i, function (r) {
    return "\u73B0\u5728" + translatePhrase(r[1]);
  }], [/^also (.*)$/i, function (r) {
    return "\u8FD8\u4F1A" + translatePhrase(r[1]);
  }], [/^renamed to (.*)$/i, function (r) {
    return "\u91CD\u547D\u540D\u4E3A" + translatePhrase(r[1]);
  }], [/^(unranked|ranked|) battleground rotation$/i, function (r) {
    return (strEq(r[1], 'unranked') ? '非排名模式' : strEq(r[1], 'ranked') ? '排名模式' : '') + "\u6218\u573A\u8F6E\u6362";
  }], [/^the battleground rotation for all (unranked|ranked) modes has been adjusted to the following$/i, function (r) {
    return "\u6240\u6709" + (strEq(r[1], 'unranked') ? '非排名模式' : strEq(r[1], 'ranked') ? '排名模式' : '') + "\u7684\u6218\u573A\u8F6E\u6362\u7684\u5730\u56FE\u6C60\u5DF2\u8C03\u6574\u4E3A\u5982\u4E0B";
  }], [/^(grants? ?)([+.0-9]+) ?(physical|spell)? armor$/gi, function (r) {
    return "" + ifExist(r[1], '给予') + r[2] + (ifExist(r[3], function (s) {
      return _.get({
        physical: '物理',
        spell: '法术'
      }, s.toLowerCase(), '');
    }) + "\u62A4\u7532");
  }], [/^(.*?)'s prices will be reduced to ([\d,]+) Gold and \$([\d,.]+) USD.$/ig, function (r) {
    return translatePhrase(r[1]) + "\u7684\u4EF7\u683C\u964D\u4F4E\u4E3A" + r[2] + "\u91D1\u5E01\u6216" + r[3] + "\u7F8E\u5143.";
  }], [/^(.+) ha(s|ve) received updated visual effects$/gi, function (r) {
    return translatePhrase(r[1]) + "\u7684\u89C6\u89C9\u6548\u679C\u5F97\u5230\u4E86\u6539\u8FDB";
  }], [/^(.+) ha(s|ve) received updated visual effects to coincide with ([a-z]+ )talent changes$/gi, function (r) {
    return translatePhrase(r[1]) + "\u7684\u89C6\u89C9\u6548\u679C\u5F97\u5230\u4E86\u66F4\u65B0\uFF0C\u4EE5\u7B26\u5408\u5929\u8D4B\u7684\u66F4\u65B0";
  }], [/^Available until (.+)$/gi, function (r) {
    return "\u9650\u65F6\u51FA\u552E\u81F3" + translatePhrase(r[1]);
  }], [/^(january|february|march|april|may|june|july|august|september|october|november|december) (\d+), (\d+)$/gi, function (r) {
    return moment(r[0], 'MMM D, YYYY').format('YYYY年M月D日');
  }], [/^neutral (.*)$/i, '中立的$1'], [/^captured (.*)$/i, '驯服的$1'], [/^available starting the week of ([^ ]+ [0-9]+) until ([^ ]+ [0-9]+).?$/i, function (r) {
    return "\u5C06\u4ECE" + moment(r[1], 'MMM D').format('M月D日') + "\u5F53\u5468\u5F00\u59CB\u4E0A\u7EBF\uFF0C" + moment(r[2], 'MMM D').format('M月D日') + "\u622A\u6B62\u3002";
  }], [/^for ([\d.]+) seconds?$/i, function (r) {
    return "\uFF0C\u6301\u7EED" + r[1] + "\u79D2";
  }]]; // Find the first `preset` that whose `preset`[0] matches `origin`,
  // then use `preset`[1] to replace it

  var replacedStr = _.reduce(regexps, function (prev, _a) {
    var re = _a[0],
        replaceTo = _a[1];

    if (prev != null) {
      return prev;
    }

    var matchResult = re.exec(origin);

    if (!matchResult) {
      return undefined;
    }

    if (typeof replaceTo === 'function') {
      return replaceTo(matchResult);
    }

    return origin.replace(re, replaceTo);
  }, undefined);

  if (replacedStr != null) {
    return replacedStr;
  }

  var presets = {
    'dragon shire': '巨龙镇',
    'tomb of the spider queen': '蛛后墓',
    'cursed hollow': '诅咒谷',
    'garden of terror': '恐魔园',
    'blackheart\'s bay': '黑心湾',
    'sky temple': '天空殿',
    'haunted mine': '鬼灵矿',
    'towers of doom': '末日塔',
    'infernal shrines': '炼狱圣坛',
    'battlefield of eternity': '永恒战场',
    'braxis holdout': '布拉克希斯禁区',
    'warhead junction': '弹头枢纽站',
    'hanamura temple': '花村寺',
    'volskaya foundry': '沃斯卡娅铸造厂',
    'alterac pass': '奥特兰克战道',
    heroes: '英雄',
    general: '综合',
    'quick navigation': '目录',
    'bug fixes': '错误修正',
    'new hero': '新英雄',
    return: '',
    miscellaneous: '综合',
    passive: '被动',
    active: '主动',
    removed: '已移除',
    'new talent': '新天赋',
    talent: '天赋',
    trait: '特质',
    'new trait': '新特质',
    abilities: '技能',
    stats: '数据',
    talents: '天赋',
    'developer comment': '开发者评论',
    'developer comments': '开发者评论',
    'ptr note': '测试服注释',
    art: '美术',
    shop: '商店',
    'user interface': '界面',
    design: '设计',
    mounts: '坐骑',
    mount: '坐骑',
    'new mounts': '新坐骑',
    'returning mounts': '重新上架的坐骑',
    'removed mounts': '下架的坐骑',
    bundles: '新礼包',
    'new bundles': '新礼包',
    'returning bundles': '重新上架的礼包',
    'removed bundles': '下架的礼包',
    skins: '新皮肤',
    'new skins': '新皮肤',
    'new portraits, sprays, and emojis': '新头像、新喷漆和新表情',
    'returning skins': '重新上架的皮肤',
    'removed skins': '下架的皮肤',
    'new mount': '新坐骑',
    assassin: '刺杀型',
    'multi-class': '混合型',
    specialist: '专业型',
    support: '辅助型',
    warrior: '战斗型',
    warriors: '战斗型',
    minions: '小兵',
    mercenaries: '雇佣兵',
    quest: '任务',
    '!quest': '任务',
    reward: '奖励',
    '!reward': '奖励',
    rewards: '奖励',
    'indicates a quest talent.': '代表该天赋为任务天赋.',
    'italic text': '斜体字',
    'bold text': '粗体字',
    underlined: '下划线',
    'indicates a': '代表',
    'text indicates a': '字代表',
    new: '新',
    moved: '移动的',
    'talent.': '天赋',
    level: '等级',
    tier: '天赋层级',
    'design & gameplay': '设计与游戏性',
    battlegrounds: '战场',
    'in-game user interface': '游戏界面',
    'draft mode': '征召模式',
    sounds: '声音',
    sound: '声音',
    'heroes, abilities, and talents': '英雄、技能和天赋',
    'basic abilities': '基本技能',
    'heroic abilities': '终极技能',
    'return to top': '',
    'the following heroes, abilities, and talents have received updated visual effects': '以下英雄、技能和天赋获得了视觉效果更新',
    'the following heroes have received updated icon art to coincide with their reworks': '以下英雄的技能图标和视觉效果已经更新，与他的新设计保持一致',
    'has received updated icon art and visual effects that coincide with his rework.': '的技能图标和视觉效果已经更新，与他的新设计保持一致',
    'has been added to the in-game shop': '已被添加到游戏商城',
    'moved to': '移到了',
    'new functionality': '新效果',
    'removed functionality': '移除效果',
    'added functionality': '新增效果',
    'additional functionality': '新增效果',
    'adjusted functionality': '调整效果',
    redesigned: '重新设计',
    'new ability': '新技能',
    'new active': '新主动激活效果',
    'heroes of the storm': '风暴英雄',
    'world of warcraft': '魔兽世界',
    'price reduction': '价格变动',
    'heroes brawl': '风暴乱斗',
    emojis: '表情',
    'try mode': '试用模式',
    defender: '防御者',
    laner: '推进者',
    forts: '堡垒',
    keeps: '要塞',
    'dot effects': '持续伤害效果',
    'basic attacks': '普通攻击',
    'quick cast': '快速施法',
    emoji: '表情',
    'loot chests': '战利品',
    collection: '收藏',
    hotkeys: '快捷键',
    'new announcer': '新播报员',
    'new announcers': '新播报员',
    'map rotation update': '地图轮换更新',
    'ranked battleground rotation update': '排名战场轮换更新',
    'ranked battleground rotation': '排名战场轮换',
    'added to rotation': '新增至轮替列表',
    'removed from rotation': '自轮替列表移除',
    'the full ranked battleground rotation is now as follows': '完整的排名对战战场轮替列表如下',
    'the ranked map rotation has been updated to include the following': '排位赛地图轮换已更新',
    'heroes & talents': '英雄与天赋',
    'target info panel': '目标信息面板',
    'new bundles and skin packs': '新的礼包和皮肤包',
    'the following new bundles will soon become available for a limited time': '以下新的礼包很快将限时上线',
    'fixed a number of typo and tooltip errors across several aspects of the game': '修复了游戏中多处拼写错误和提示文字错误',
    note: '注'
  };
  var result = origin;

  _.map(presets, function (_toS, fromS) {
    if (_.trim(origin.toLowerCase()) === fromS) {
      result = presets[fromS];
      return false;
    }

    return null;
  });

  return result;
}

function parseUnit(str) {
  var cutPercentage = cutPrefix(str, '%');
  var percentage = cutPercentage !== str;
  var matchPer = /^(.*?) ?(?:per (.*))?$/i.exec(_.trim(cutPercentage));
  var unit = matchPer ? _.trim(matchPer[1]) : '';
  var per = matchPer ? _.trim(matchPer[2]) : '';
  return {
    unit: unit,
    percentage: percentage,
    per: per
  };
}

function parsePerFromProperty(str) {
  var matchPer = /(.*) per (.*)/i.exec(str);

  if (matchPer) {
    return [_.trim(matchPer[1]), _.trim(matchPer[2])];
  }

  return [_.trim(str), ''];
}

function standardizeNum(numStr) {
  if (!numStr) {
    return '';
  }

  var result = numStr.replace(',', '');

  if (numStr.startsWith('.')) {
    result = "0" + numStr;
  }

  return result;
}

function cutPrefix(origin, prefixes) {
  var prefixesArr = typeof prefixes === 'string' ? [prefixes] : prefixes;

  for (var _i = 0, prefixesArr_1 = prefixesArr; _i < prefixesArr_1.length; _i++) {
    var prefix = prefixesArr_1[_i];

    if (origin.startsWith(prefix)) {
      return origin.slice(prefix.length);
    }
  }

  return origin;
}

function cutSuffix(origin, suffixes) {
  var suffixesArr = typeof suffixes === 'string' ? [suffixes] : suffixes;

  for (var _i = 0, suffixesArr_1 = suffixesArr; _i < suffixesArr_1.length; _i++) {
    var suffix = suffixesArr_1[_i];

    if (origin.endsWith(suffix)) {
      return origin.slice(0, origin.length - suffix.length);
    }
  }

  return origin;
} // tslint:disable-next-line:max-func-body-length


function translateProperty(origin) {
  if (!origin) {
    return '';
  }

  var tryingCutting = origin.toLowerCase();
  var afterPrefixes = [];
  var prefixMinMax = '';
  var afterSuffixes = [];
  var suffixAmount = '';

  while (true) {
    var beforeCutting = tryingCutting;
    tryingCutting = cutPrefix(tryingCutting, ['max ', 'maximum ']);

    if (tryingCutting !== beforeCutting) {
      prefixMinMax = '最大';
      continue;
    }

    tryingCutting = cutPrefix(tryingCutting, ['min ', 'minimum ']);

    if (tryingCutting !== beforeCutting) {
      prefixMinMax = '最小';
      continue;
    }

    tryingCutting = cutPrefix(tryingCutting, 'base ');

    if (tryingCutting !== beforeCutting) {
      afterPrefixes.push('基础');
      continue;
    }

    tryingCutting = cutPrefix(tryingCutting, 'bonus ');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('加成');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, [' bonus', ' gain', ' granted']);

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('加成');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' refund');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('返还');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, [' regen', ' regeneration']);

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('回复速度');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' duration');

    if (tryingCutting !== beforeCutting) {
      beforeCutting = tryingCutting;
      tryingCutting = cutSuffix(tryingCutting, ' reduction');

      if (tryingCutting !== beforeCutting) {
        afterSuffixes.push('降低效果持续时间');
        continue;
      }

      afterSuffixes.push('持续时间');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' restoration');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('回复');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' scaling');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('成长');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' reduction');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('降低量');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' increase');

    if (tryingCutting !== beforeCutting) {
      afterSuffixes.push('增加量');
      continue;
    }

    tryingCutting = cutSuffix(tryingCutting, ' amount');

    if (tryingCutting !== beforeCutting) {
      suffixAmount += '量';
      continue;
    }

    break;
  }

  var rootDict = {
    health: '生命值',
    mana: '法力',
    'mana cost': '法力消耗',
    'energy cost': '能量消耗',
    cooldown: '冷却时间',
    'cast time': '施法时间',
    radius: '半径',
    range: '范围',
    healing: '治疗量',
    heal: '治疗量',
    damage: '伤害',
    armor: '护甲',
    shield: '护盾',
    'spell armor': '法术护甲',
    'physical armor': '物理护甲',
    vision: '视野',
    'vision range': '视野范围',
    'sight radius': '视野范围',
    charges: '可储存次数',
    stacks: '层数',
    'movement speed': '移动速度',
    'spell power': '法力强度',
    'basic attack': '普通攻击',
    'attack speed': '普通攻击速度',
    'basic attack speed': '普通攻击速度',
    'attack damage': '普通攻击伤害',
    'basic attack damage': '普通攻击伤害',
    'basic attack range': '普通攻击范围',
    'movement speed slow': '减速效果',
    'increased movement speed': '加速效果',
    slow: '减速效果',
    root: '定身',
    silence: '沉默',
    stun: '昏迷',
    blind: '致盲',
    'cast range': '施放距离',
    'full charge up': '最大蓄力',
    'life leech': '生命吸取',
    'search arc': '搜寻弧度',
    duration: '持续时间',
    'spell damage': '法术伤害',
    'physical damage': '物理伤害',
    'damage over time': '持续伤害',
    'splash damage': '溅射伤害',
    'impact damage': '直接伤害',
    'window between casts': '每次施法之间的最大时间间隔',
    'damage threshold': '伤害阈值',
    'dash range': '冲刺距离',
    'charge count': '储存层数',
    'explosion radius': '爆炸范围',
    'teleport range': '传送距离',
    'leash range': '脱战范围'
  };
  var afterRoot = rootDict[tryingCutting] || tryingCutting;

  if (afterRoot.endsWith('量')) {
    suffixAmount = '';
  }

  return _.join([_.join(afterPrefixes, ''), prefixMinMax, afterRoot, suffixAmount, _.join(_.reverse(afterSuffixes), '')], '');
}

function translateUnit(origin) {
  if (!origin) {
    return ['', ''];
  }

  var plural = pluralize(origin);
  var dict = {
    seconds: ['', '秒'],
    'maximum healths': ['最大生命值的', ''],
    'max healths': ['最大生命值的', '']
  };
  return dict[plural.toLowerCase()] || ['', origin];
}

function translatePer(origin) {
  if (!origin) {
    return ['', ''];
  }

  var plural = pluralize(origin);
  var dict = {
    'basic attacks': ['每次普通攻击的', ''],
    stacks: ['每层的', ''],
    seconds: ['', '每秒'],
    ticks: ['', '每跳']
  };
  return dict[plural.toLowerCase()] || ["\u6BCF" + (origin || '') + "\u7684", ''];
}

export function translateChangeFromTo(origin) {
  var matches = /^(.*? )(?:(reduce|lower|decrease|increase|change)(?:s|e?d|) )?from ([\d.,]+)(%?(?: [^.,]+?)?) to ([\d.,]+)(%?(?: [^.,]+)?)$/i.exec(origin);

  if (!matches) {
    return null;
  }

  var property = _.trim(matches[1] || '').toLowerCase();

  var specifiedTrend = (matches[2] || '').toLowerCase();
  var fromNumStr = matches[3];
  var fromUnit = matches[4] || '';
  var toNumStr = matches[5];
  var toUnit = matches[6] || '';
  var trendUp = specifiedTrend && !['change'].includes(matches[2]) ? ['increase'].includes(specifiedTrend) : parseFloat(standardizeNum(toNumStr)) > parseFloat(standardizeNum(fromNumStr));
  var fromUnitParsed = parseUnit(fromUnit);
  var toUnitParsed = parseUnit(toUnit);

  var _a = parsePerFromProperty(property),
      bareProperty = _a[0],
      perFromProperty = _a[1];

  var perStr = perFromProperty || fromUnitParsed.per || toUnitParsed.per;
  var afterProperty = translateProperty(bareProperty);
  var afterTrend = trendUp ? '增加' : '降低';
  var afterFromNum = standardizeNum(fromNumStr) + (fromUnitParsed.percentage ? '%' : '');
  var afterToNum = standardizeNum(toNumStr) + (toUnitParsed.percentage ? '%' : ''); // Process units

  var afterFromUnit = fromUnitParsed.unit ? translateUnit(fromUnitParsed.unit) : translateUnit(toUnitParsed.unit);
  var afterToUnit = translateUnit(toUnitParsed.unit);

  var _b = translatePer(perStr),
      afterPerAtStart = _b[0],
      afterPerAtNum = _b[1];

  return _.join([afterPerAtStart, afterProperty, '从', afterFromUnit[0], afterPerAtNum, afterFromNum, afterFromUnit[1], afterTrend, '到', afterToUnit[0], afterToNum, afterToUnit[1]], '');
}
export function translateChangeBy(origin) {
  var matches = /^(reduce|lower|decrease|increase)(?:s|e?d|) (.*) by (~?)([\d.,]+)(%?(?: [^.,]+?)?)$/i.exec(origin);

  if (!matches) {
    matches = /^(.*) (reduce|lower|decrease|increase)(?:e?d) by (~?)([\d.,]+)(%?(?: [^.,]+?)?)$/i.exec(origin);

    if (matches) {
      var property_1 = matches[1];
      matches[1] = matches[2];
      matches[2] = property_1;
    }
  }

  if (!matches) {
    return null;
  }

  var specifiedTrend = (matches[1] || '').toLowerCase();

  var property = _.trim(matches[2] || '').toLowerCase();

  var approxStr = matches[3];
  var byNumStr = matches[4];
  var byUnit = matches[5] || '';
  var trendUp = ['increase'].includes(specifiedTrend);
  var byUnitParsed = parseUnit(byUnit);

  var _a = parsePerFromProperty(property),
      bareProperty = _a[0],
      perFromProperty = _a[1];

  var perStr = perFromProperty || byUnitParsed.per;
  var percentage = byUnitParsed.percentage;
  var afterProperty = translateProperty(bareProperty);
  var afterTrend = trendUp ? '增加' : '降低';
  var afterApprox = approxStr ? '约' : '';
  var afterByNum = standardizeNum(byNumStr) + (percentage ? '%' : '');

  var _b = translateUnit(byUnitParsed.unit),
      afterUnitFront = _b[0],
      afterUnitBack = _b[1];

  var _c = translatePer(perStr),
      afterPerAtStart = _c[0],
      afterPerAtNum = _c[1];

  return _.join([afterPerAtStart, afterProperty, afterTrend, afterApprox, afterUnitFront, afterPerAtNum, afterByNum, afterUnitBack], '');
}

function translateToken(origin) {
  var queryResult = i18nDict[toI18nKey(origin)];

  if (queryResult) {
    return queryResult;
  }

  var tryChangeFromTo = translateChangeFromTo(origin);

  if (tryChangeFromTo) {
    return tryChangeFromTo;
  }

  var tryChangeBy = translateChangeBy(origin);

  if (tryChangeBy) {
    return tryChangeBy;
  }

  return translatePreset(origin);
}

export function translatePhrase(origin) {
  if (!origin) {
    return '';
  }

  if ( // tslint:disable-next-line:no-http-string
  origin.startsWith('http://') || origin.startsWith('https://')) {
    return origin;
  }

  var validSplit;

  _.forEach([splitBracket, splitSquareBracket, splitColon, splitXXXTalents, splitDash], function (splitMethod) {
    var splitResult = splitMethod(origin);

    if (splitResult) {
      validSplit = splitResult;
      return false;
    }
  });

  if (validSplit) {
    var originTokens = validSplit[0],
        recoverFunc = validSplit[1];
    return recoverFunc.apply(void 0, originTokens.map(translatePhrase));
  }

  return translateToken(origin);
}
export function translateTree(node) {
  if (node.kind === 'text') {
    var replaced = node.text.replace('’', '\'').replace(' ', ' ').replace('ú', 'u').replace(String.fromCharCode(10), ' ').replace(String.fromCharCode(160), ' ').replace(String.fromCharCode(8203), ' ');

    var result = _.trim(replaced);

    return __assign(__assign({}, node), {
      text: translatePhrase(result)
    });
  }

  return __assign(__assign({}, node), {
    children: node.children.map(translateTree)
  });
}